module.exports = __webpack_public_path__ + "assets/media/day21.c785cbb4.mp3";